/* esm.sh - lib0@0.2.117/mutex */
var n=()=>{let e=!0;return(r,t)=>{if(e){e=!1;try{r()}finally{e=!0}}else t!==void 0&&t()}};export{n as createMutex};
//# sourceMappingURL=mutex.mjs.map